import React from "react"
import { FileLinkCommentPanel } from "../../../designSystem/compositeComponents/FileLinkCommentPanel";
import { Label } from "../../../designSystem/Label";
import { ReferenceLinksPanel, ReferenceLinksPanelCollapsible } from '../../../designSystem/compositeComponents/ReferenceLinksPanel';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { CommentPanel } from "../../../designSystem/compositeComponents/CommentPanel";
import { ProtectedPageContext } from "../../_contexts/ProtectedPageContext";
import { ReferenceFilesPanel, ReferenceFilesPanelCollapsible } from '../../../designSystem/compositeComponents/ReferenceFilesPanel';


export const FileLinkCommentOverview = (): JSX.Element => 
{
    const activeUser = React.useContext(ProtectedPageContext).user;

    const id = '123';

    return (
        <Flex flexDirection="column" gap={48}>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>FileLinkCommentPanel</Label>                       
                <FileLinkCommentPanel stretch
                    tooltip="Her er et tooltip eksempel"
                    fileReference={{ type: 'None', id: id }}
                    linkReference={{ type: 'None', id: id }}
                    commentReference={{ type: 'None', id: 'designsystem' }}
                />
            </div>
           
            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>CommentPanel</Label>                       
                <CommentPanel
                    commentReference={{ type: 'None', id: id }}
                    activeUser={activeUser}
                />
            </div>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>ReferenceLinksPanel</Label>                       
                <ReferenceLinksPanel
                    reference={{ type: 'None', id: id }}
                />
            </div>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>ReferenceLinksPanelCollapsible</Label>                       
                <ReferenceLinksPanelCollapsible
                    reference={{ type: 'None', id: id }}
                />
            </div>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>ReferenceFilesPanel</Label>                       
                <ReferenceFilesPanel
                    referenceType="None"
                    objectId={id}
                />
            </div>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>ReferenceFilesPanelCollapsible</Label>                       
                <ReferenceFilesPanelCollapsible
                    referenceType="None"
                    objectId={id}
                />
            </div>
  
        </Flex>
    )
}
